<script>
import { tour } from '../tour'
import { fly } from 'svelte/transition';

/*____________ Tour Variables ____________*/
export let title = tour.title;
export let scenes;
export let nextScene = tour.nextScene;
export let prevScene = tour.prevScene;
export let hasCategories = false;
scenes = scenes || [];

let currentSceneName;
function getCurrentSceneName(){
    currentSceneName = window.CC.krpano.get("xml.scene");
    return currentSceneName;
}

function loadScene(scene){
    // not sure if async helps with speed or not.
    (async () => {
        window.CC.krpano.call("loadscene("+scene.name+",null,get(skin_settings.loadscene_flags),get(skin_settings.loadscene_blend));");
    })();

    visible = false;
}

let currentCategory = null;
let categories = []; // categories found in scenes 
let visibleScenes = scenes; // scenes for the current category

/*____________ Component Variables ____________*/

let thumbsgrid; //bind on .thumbsgrid for scrolling behavior
var thumbs = []; //bind on .thumbs for scrolling behavior
let visible = false; // visibility of thumbs grid

// Fire event every time thumb grid visibility changes
$: if(visible || visible == false){
    dispatchEvent(new CustomEvent('krpano:gridtoggle', {
		detail: { grid: visible }
	}));
}

// Gets categories when scenes[] is set
$: if (scenes && hasCategories) {
    categories = getCategories();
}

// Converts title case --> Title Case 
function titleCase(str) {
   let words = str.toLowerCase().split(' ');
   for (let i = 0; i < words.length; i++) {
       words[i] = words[i].charAt(0).toUpperCase() + words[i].substring(1);     
   }
   return words.join(' '); 
}

// Gets categories from scenes[]
function getCategories(){
    const result = [];
    const map = new Map();
    for (const item of scenes) {
        if(!map.has(item.category)){
            map.set(item.category, true);
            let title = titleCase( item.category.replace('_', ' ') );
            result.push({ title: title, name: item.category });
        }
    }
    return result;
}

function getSceneFromName(name){
    return scenes.find((s)=> s.name === name)   
}

// Sets visibleScenes[] according to current category
function changeCategory(category){
    currentCategory = category;
    if(category){
        visibleScenes = scenes.filter(scene => scene.category === category);
    } else {
        visibleScenes = scenes; // null category used for ALL
    }
    return visibleScenes;
}

function showThumbs(){
    if(scenes.length === 0){
        scenes = window.CC.krpano.get('scene').getArray();
        visibleScenes =  scenes;
    }

    getCurrentSceneName();
    scrollToActiveThumb();
    visible = true;
}

function toggleThumbs(){
    visible ? visible = false : showThumbs();
}

function sleep(milliseconds) {  
      return new Promise(resolve => setTimeout(resolve, milliseconds));  
}  

function scrollToActiveThumb(){
    let activeSceneIndex = visibleScenes.findIndex(scene => scene.name === currentSceneName );
    if(activeSceneIndex !== -1 && thumbs[activeSceneIndex]){
        window.scrollthumb = thumbs[activeSceneIndex];
        thumbs[activeSceneIndex].scrollIntoView();
        console.log(activeSceneIndex)
    }
}

function _loadScene(scene){
    loadScene(scene)
    visible = false;
}
</script>

<style>
:root {
    --textcolor: #fff;
    --minRangeValue: 200px;
}

h1.tour-title {
    text-align: center;
    font-family: 'Roboto', sans-serif;
    font-size: 2rem;
}

div.thumbs-container {
        background: rgba(var(--thumb-grid-color-rgb),0.8);
        color: white;
        position: fixed;
        width: 100%;
        max-width: 100%;
        height: 100%;
        z-index: 1000;
        left: 0;
        bottom: -101%;
        display: block;
        transition: all 1000ms;
        visibility: hidden;
}

.thumbs-container.active {
    bottom: 0;
    visibility: visible;
}

.thumbs-container main {
    width: 100%;
    height: 100%;
    height: calc(100% - 165px);
    position: relative;
}

.thumbsgrid {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}

::-webkit-scrollbar {
 width: 10px;
}
::-webkit-scrollbar-thumb {
 background: #fff;
}

::-webkit-scrollbar-thumb:hover{
    background: #ddd;
}

.bottom-menu {
    background: rgba(var(--primary-color-rgb),0.8);
    position: fixed;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    z-index: 1001;
    padding: 0.5rem;
    border-radius: 10px 10px 0 0;
}

.bottom-menu:hover {
    background: rgba(var(--primary-color-rgb),1);
    /* border: 3px solid rgba(255,255,255,1);
    border-width: 3px 3px 0 3px; */
}

.thumbs-button {
    background-image: url(../images/gridbut.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    width: 45px;
    height: 45px;
    cursor: pointer;
}

.thumbs-button.active {
    background-position: 0 -45px;
}

.thumbsgrid-view {
  margin: 3rem 0;
  list-style: none;
  margin: 0;
  padding: 0;  
  outline: none;
  border: none;
}

.thumbsgrid-view li {
  color: var(--textcolor);
  cursor: pointer;
  border:5px solid transparent;
  border-radius: 10px;
}

.thumbsgrid-view li:hover {
    border:5px solid #fff;
}

.thumbsgrid-view li.active {
    border:5px solid #fff;
}

.thumbsgrid-view {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
  margin: auto;
  width: 95%;
  margin-bottom: 100px;
}

.thumbsgrid-view figure{
    width: 100%;
    height: 100%;
}

.thumbsgrid-view img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-height: 225px;
    border-radius: 10px;
}

.thumbsgrid-view figure {
    position: relative;
    padding: 0;
    margin: 0;
}

.thumbsgrid-view figcaption {
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    text-align: center;
}

.thumbsgrid-view figcaption h2 {
    background: rgba(var(--thumb-grid-color-rgb), 0.8);
    
    padding: 8px;
    margin: 0;
    display: inline-block;
    border-radius: 5px;
    text-align: center;
    font-size: 1em;
    font-weight: 500;
    font-family: 'Raleway';
}

.scene-categories {
    list-style: none;
    margin: 1rem 0;
    padding: 0;  
    outline: none;
    border: none;
}
.scene-categories li {
    border: 2px solid #fff;
    display: inline-block;
    padding: 0.5rem 1rem;
    margin: 0.15rem;
    cursor: pointer;
}

.scene-categories li:hover {
    background: #fff;
    color: #000;
}

.scene-categories li.active {
    background: #fff;
    color: #000;
}


/* Next / Prev */
.prev-button, .next-button {
    /* padding: 0 12px; */
    cursor: pointer;
}

.next-button img {
    transform: scaleX(-1);
}

.bottom-menu {
    display: flex;
}
.bottom-menu div {
    display: flex;
    width: 45px;
    height: 45px;
    margin: 0 8px;
    justify-content: center;
    align-items: center;

  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}


@media only screen and (max-width: 600px) {
  .thumbsgrid-view {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));      
  }

  .thumbs-container main {
    height: calc(100% - 176px);
  }

  h1.tour-title {
      font-size: 2rem;
  }

  .thumbsgrid-view figcaption h2 {
      font-size: 12px;
  }

}
</style>

<!-- if method removes from DOM and makes scrolling a problem -->
<!-- {#if visible} -->
<!-- <div class="thumbs-container" transition:fly={{y: window.innerHeight, duration: 1000 }}> -->

<!-- other method (scrolling worked on this one) -->
<!-- class:active={visible}  -->
<div class="thumbs-container" class:active={visible}>
    <header>
        <!-- Title -->
        <h1 class="tour-title">{@html title}</h1>
        <!-- Categories -->

        {#if categories.length > 0}
        <ol class="scene-categories">
            {#each categories as c}
            <li class:active={currentCategory === c.name} on:click={()=> changeCategory(c.name)}>
                {c.title}
            </li>
            {/each}
            <li class:active={!currentCategory} on:click={()=> {changeCategory()}}>
                All
            </li>
        </ol>
        {/if}
    </header>

    <main>
        <!-- Grid -->
        <div  class="thumbsgrid" bind:this={thumbsgrid}>
            <ol class="thumbsgrid-view">
                <!-- Scenes -->
                {#each visibleScenes as s,i}
                    <li class:active={currentSceneName === s.name} bind:this={thumbs[i]}>
                        <figure class="thumb" on:click={_loadScene(s)}>
                            <img src="{s.thumburl}" width="150" height="150" alt="{s.title}"/>
                            <figcaption>
                                <h2>{@html tour.parseContent(s.title)}</h2>
                            </figcaption>
                        </figure>
                    </li>
                {/each}
            </ol>
        </div>
    </main>
</div><!-- /  .thumbs-container -->

<!-- {/if} -->
<!-- (not using if method...) -->

<!-- Button -->
<div class="bottom-menu" transition:fly={{y: 300, duration: 500 }}>
    <div class="prev-button" on:click={()=>{prevScene(); visible = false; }}>
        <img src="./images/direction.png" width="35" height="35" alt="Prev Scene"/>
    </div>
    <div class="thumbs-button" class:active={visible} on:click={toggleThumbs}/>
    <div class="next-button" on:click={()=>{nextScene(); visible = false; }}>
        <img src="./images/direction.png" width="35" height="35" alt="Next Scene"/>
    </div>
</div>